export default __webpack_public_path__ + "9e1ba198c6fecaa4c63da8cd96e5f0f6.png";